import { loadModules } from "esri-loader";

export default class ArrowLineLayer {
  private static intances: Map<string, ArrowLineLayer>;
  private animateLayers: Array<any> = new Array<any>();
  private markLayer?: __esri.GraphicsLayer;
  private layerId: string = "";
  private lineBgColor: Array<number> = [0, 0, 255, 255];
  private lineColor: Array<number> = [0, 112, 225, 255];
  private arrowColor: Array<number> = [255, 255, 255, 255];

  public static getInstance(view: __esri.MapView) {
    const id = view.container.id;
    if (!ArrowLineLayer.intances) {
      ArrowLineLayer.intances = new Map();
    }
    let instance = ArrowLineLayer.intances.get(id);
    if (!instance) {
      instance = new ArrowLineLayer(view);
      ArrowLineLayer.intances.set(id, instance);
    }
    return instance;
  }

  private view!: __esri.MapView;
  private startPointSymbol: any = {
    type: "picture-marker",
    url: "assets/mapIcons/icon_start.png",
    width: 30,
    height: 48,
    yoffset: 24,
  };
  private endPointSymbol: any = {
    type: "picture-marker",
    url: "assets/mapIcons/icon_end.png",
    width: 30,
    height: 48,
    yoffset: 24,
  };

  private constructor(view: __esri.MapView) {
    this.view = view;
  }
  private clear(id?: string | undefined) {
    if (this.animateLayers.length > 0) {
      this.animateLayers.forEach((animationObj) => {
        if (animationObj.layer.id == id || id === undefined) {
          animationObj.start = false;
          this.view.map.remove(animationObj.layer);
        }
      });
    }
    if (this.markLayer) {
      this.markLayer.removeAll();
    }
  }
  public clearArrowLayer() {
    this.clear();
  }

  public async initialize(params?: any) {
    let features = params && params.features;
    let layerIndex = (params && params.layerIndex) || -1;
    let selLayer: any;
    if (features) {
      selLayer = await this.createLayer(features, layerIndex);
    } else {
      this.view.map.allLayers.toArray().forEach((layer: any, index: number) => {
        if (layer.type == "feature" && (layer as any).showArrow) {
          selLayer = layer;
          layerIndex = index;
        }
      });
    }
    let _this = this;
    if (selLayer) {
      let animationObj = {
        layer: selLayer,
        aIndex: 1,
        start: true,
      };
      this.animateLayers.push(animationObj);
      setTimeout(() => {
        _this.animationLine(animationObj);
      }, 50);
    }
  }
  private async createLayer(features: __esri.Graphic[], layerIndex?: number) {
    if (this.layerId !== "") {
      this.clear(this.layerId);
    }

    type MapModules = [
      typeof import("esri/layers/FeatureLayer"),
      typeof import("esri/layers/GraphicsLayer"),
      typeof import("esri/Graphic"),
      typeof import("esri/Color")
    ];
    const [FeatureLayer, GraphicsLayer, Graphic, Color] = await (loadModules([
      "esri/layers/FeatureLayer",
      "esri/layers/GraphicsLayer",
      "esri/Graphic",
      "esri/Color",
    ]) as Promise<MapModules>);
    let line: __esri.Polyline = features[0].geometry as __esri.Polyline;
    let layer = new FeatureLayer({
      source: features,
      objectIdField: "OBJECTID",
      geometryType: "polyline",
      outFields: ["*"],
      spatialReference: features[0].geometry.spatialReference,
      fields: [
        { name: "OBJECTID", type: "oid" },
        { name: "id", type: "string" },
      ],
    });
    layer.renderer = {
      type: "simple",
      symbol: {
        type: "cim",
        data: {
          type: "CIMSymbolReference",
          symbol: {
            type: "CIMLineSymbol",
            symbolLayers: [
              {
                type: "CIMSolidStroke",
                enable: true,
                width: 6,
                color: this.lineColor,
              },
              {
                type: "CIMSolidStroke",
                enable: true,
                width: 7,
                color: this.lineBgColor,
              },
              {
                type: "CIMVectorMarker",
                enable: true,
                size: 6,
                markerPlacement: {
                  type: "CIMMarkerPlacementAlongLineSameSize",
                  endings: "Custom",
                  placementTemplate: [14],
                  offsetAlongLine: 0,
                },
                frame: {
                  xmin: -6,
                  ymin: -6,
                  xmax: 6,
                  ymax: 6,
                },
                markerGraphics: [
                  {
                    type: "CIMMarkerGraphic",
                    geometry: {
                      paths: [
                        [
                          [-8, 5],
                          [0, 0],
                          [-8, -5],
                        ],
                      ],
                    },
                    symbol: {
                      type: "CIMLineSymbol",
                      symbolLayers: [
                        {
                          type: "CIMSolidStroke",
                          enable: true,
                          color: this.arrowColor,
                          width: 2,
                        },
                      ],
                    },
                  },
                ],
              },
            ],
          },
        },
      },
    } as any;
    this.layerId = layer.id;
    if (layerIndex && layerIndex > 0) {
      this.view.map.add(layer, layerIndex);
    } else {
      this.view.map.add(layer);
    }
    if (!this.markLayer) {
      this.markLayer = new GraphicsLayer();
      this.view.map.add(this.markLayer);
    }

    if (1) {
      let startGra = new Graphic({
        geometry: line.getPoint(0, 0),
        symbol: this.startPointSymbol,
        attributes: {},
      });
      this.markLayer.add(startGra);
      let endGra = new Graphic({
        geometry: line.getPoint(0, line.paths[0].length - 1),
        symbol: this.endPointSymbol,
        attributes: {},
      });
      this.markLayer.add(endGra);
    }

    return layer;
  }
  private animationLine(animationObj: {
    layer: any;
    aIndex: number;
    start: boolean;
  }) {
    let selLayer = animationObj.layer;
    let offset = (animationObj.aIndex % 20) + 1;
    if (selLayer.loaded) {
      selLayer.renderer = {
        type: "simple",
        symbol: {
          type: "cim",
          data: {
            type: "CIMSymbolReference",
            symbol: {
              type: "CIMLineSymbol",
              symbolLayers: [
                {
                  type: "CIMSolidStroke",
                  enable: true,
                  width: 6,
                  color: this.lineColor,
                },
                {
                  type: "CIMSolidStroke",
                  enable: true,
                  width: 7,
                  color: this.lineBgColor,
                },
                {
                  type: "CIMVectorMarker",
                  enable: true,
                  size: 6,
                  markerPlacement: {
                    type: "CIMMarkerPlacementAlongLineSameSize",
                    endings: "Custom",
                    placementTemplate: [14],
                    offsetAlongLine: offset,
                  },
                  frame: {
                    xmin: -6,
                    ymin: -6,
                    xmax: 6,
                    ymax: 6,
                  },
                  markerGraphics: [
                    {
                      type: "CIMMarkerGraphic",
                      geometry: {
                        paths: [
                          [
                            [-8, 5],
                            [0, 0],
                            [-8, -5],
                          ],
                        ],
                      },
                      symbol: {
                        type: "CIMLineSymbol",
                        symbolLayers: [
                          {
                            type: "CIMSolidStroke",
                            enable: true,
                            color: this.arrowColor,
                            width: 2,
                          },
                        ],
                      },
                    },
                  ],
                },
              ],
            },
          },
        },
      };
      animationObj.aIndex = offset + 1;
    }
    let _this = this;
    setTimeout(() => {
      if (animationObj.start) {
        _this.animationLine(animationObj);
      }
    }, 200);
  }
}
